import React, { useState } from 'react';
import { supabase } from '../../supabaseClient';
import ReactConfetti from 'react-confetti';

const GetInTouch = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    companyName: '',
    jobTitle: '',
    phone: '',
    hearAbout: '',
    message: ''
  });

  const [status, setStatus] = useState(null);
  const [showConfetti, setShowConfetti] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('submitting');

    const mappedFormData = {
      first_name: formData.firstName,
      last_name: formData.lastName,
      email: formData.email,
      company_name: formData.companyName,
      job_title: formData.jobTitle,
      phone: formData.phone,
      hear_about: formData.hearAbout,
      message: formData.message
    };

    try {
      const { data, error } = await supabase
        .from('contact_submissions')
        .insert([mappedFormData]);

      if (error) throw error;

      setStatus('success');
      setShowConfetti(true);
      setTimeout(() => setShowConfetti(false), 5000);

      // Reset form after submission
      setFormData({
        firstName: '',
        lastName: '',
        email: '',
        companyName: '',
        jobTitle: '',
        phone: '',
        hearAbout: '',
        message: ''
      });
    } catch (error) {
      console.error('Error submitting form:', error);
      setStatus('error');
    }
  };
// I changed First Name to Name and removed Last Name. I also removed job title and phone which aren't really required. I also made 'how did you hear' not required.
  return (
    <section className="get-in-touch">
      {showConfetti && <ReactConfetti />}
      <div className="container">
        <div className="get-in-touch-content">
          <div className="get-in-touch-text">
            <h2>Get in touch with us</h2>
            <p>Dysun makes it possible to handle your field and customer cases instantly, while reducing your costs significantly.</p>
            <p>Contact us to learn more about how you can use Dysun to take your technical support to the next level.</p>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="firstName">NAME *</label>
                <input
                  type="text"
                  id="firstName"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  required
                />
              </div>
              {/* <div className="form-group">
                <label htmlFor="lastName">LAST NAME *</label>
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  required
                />
              </div> */}
            </div>
            <div className="form-group">
              <label htmlFor="email">EMAIL *</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="companyName">COMPANY NAME *</label>
              <input
                type="text"
                id="companyName"
                name="companyName"
                value={formData.companyName}
                onChange={handleChange}
                required
              />
            </div>
            {/* <div className="form-row">
              <div className="form-group">
                <label htmlFor="jobTitle">JOB TITLE</label>
                <input
                  type="text"
                  id="jobTitle"
                  name="jobTitle"
                  value={formData.jobTitle}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label htmlFor="phone">PHONE</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                />
              </div>
            </div> */}
            <div className="form-group">
              <label htmlFor="hearAbout">HOW DID YOU HEAR ABOUT DYSUN?</label>
              <input
                type="text"
                id="hearAbout"
                name="hearAbout"
                value={formData.hearAbout}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="message">ASK US ANYTHING</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
              ></textarea>
            </div>
            <button type="submit" className="submit-button" disabled={status === 'submitting'}>
              {status === 'submitting' ? 'Submitting...' : 'Submit'}
            </button>
          </form>
          {status === 'success' && (
            <div className="success-message">
              Thank you for your submission! We'll get back to you soon.
            </div>
          )}
          {status === 'error' && (
            <div className="error-message">
              Oops! Something went wrong. Please try again later.
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default GetInTouch;